<template>
  <div>
    <router-link :to="'/leadDetail/' + rowall.id">
      <div
        class="w-60 text-left text-primary-900 flex space-x-2 items-center justify-start"
      >
        <svg class="w-4 h-4 text-tile-500" viewBox="0 0 256 256">
          <path
            fill="currentColor"
            d="M231.9 212a120.7 120.7 0 0 0-67.1-54.2a72 72 0 1 0-73.6 0A120.7 120.7 0 0 0 24.1 212a8 8 0 1 0 13.8 8a104.1 104.1 0 0 1 180.2 0a8 8 0 1 0 13.8-8ZM72 96a56 56 0 1 1 56 56a56 56 0 0 1-56-56Z"
          />
        </svg>
        <span> {{ rowall.name }}</span>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "id",
  data() {
    return {
      link: "edit/" + this.input.table,
      model: null
    };
  },
  props: ["input", "form", "rowdata", "rowall"],
  created() {
    this.model = this.rowdata;
    if (this.input.options) {
      this.link = this.input.options;
    }
  },
  watch: {
    form() {
      if (this.form) {
        this.model = null;
      }
    },
    model() {
      this.$parent.$emit("change", {
        name: this.input.name,
        value: this.model
      });
    }
  }
};
</script>

<style></style>
